import * as Sentry from '@sentry/browser';
import Vue from 'vue';

Sentry.init({
  dsn: 'https://9c834e1cca7748279dd402babbd4916d@sentry.io/1320213',
  integrations: [new Sentry.Integrations.Vue({ Vue })],
  beforeSend(event) {
    return process.env.NODE_ENV === 'production' ? event : null;
  },
});
